<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/ir">Imposto de Renda</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Detalhes</li>
                <li class="breadcrumb-item active" aria-current="page">{{ ir.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-info">
                    <strong>Protocolo:</strong> {{ ir.protocol }}
                </div>
            </div>
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Accordion -->
                    <a href="#dataGeneralCompany" class="d-block card-header py-3" data-toggle="collapse" role="button"
                        aria-expanded="true" aria-controls="dataGeneralCompany">
                        <h6 class="m-0 font-weight-bold text-primary"><i class="fa fa-caret-right"></i> Dados do(a)
                            declarante
                        </h6>
                    </a>
                    <!-- Card Header - Dropdown -->
                    <div class="collapse" id="dataGeneralCompany">
                        <div class="card-body">
                            <form @submit="update('personal_data', $event)">
                                <div class="row mt-2">
                                    <div class="col-xl-4 col-md-4 col-sm-12">
                                        <label for="">CPF / CNPJ*</label>
                                        <div class="input-group mb-3">
                                            <input type="text" class="form-control" placeholder="Ex: xxx.xxx.xxx-xx"
                                                v-model="ir.document" v-mask="['###.###.###-##', '##.###.###/####-##']">

                                        </div>
                                    </div>
                                    <div class="col-xl-8 col-md-8 col-sm-12">
                                        <label for="">Nome*</label>
                                        <input type="text" class="form-control" placeholder="Ex: João da Silva"
                                            v-model="ir.name">
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-xl-6 col-md-6 col-sm-12">
                                        <label for="">E-mail*</label>
                                        <div class="input-group mb-3">
                                            <input type="email" class="form-control"
                                                placeholder="Ex: usuario@dominio.com" v-model="ir.email">

                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-md-6 col-sm-12">
                                        <label for="">Telefone*</label>
                                        <input type="text" class="form-control" placeholder="(xx)x.xxxx-xxxx"
                                            v-model="ir.phone" v-mask="['(##) ####-####', '(##) #####-####']">
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-xl-6 col-md-6 col-sm-12">
                                        <label for="">Valor a ser restituido</label>
                                        <div class="input-group mb-3">
                                            <input type="text" class="form-control" placeholder="R$0,00"
                                                v-model.lazy="ir.amount_received" v-money="money">

                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-md-6 col-sm-12">
                                        <label for="">Valor a pagar</label>
                                        <input type="text" class="form-control" placeholder="R$0,00"
                                                v-model.lazy="ir.amount_pay" v-money="money">
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                class="fa fa-save"></i> Atualizar</button>
                                        <router-link to="/category" class="btn btn-danger ml-3"><i
                                                class="fa fa-times"></i>
                                            Cancelar</router-link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Accordion -->
                    <a href="#taxable_income" class="d-block card-header py-3" data-toggle="collapse" role="button"
                        aria-expanded="true" aria-controls="taxable_income">
                        <h6 class="m-0 font-weight-bold text-primary"><i class="fa fa-caret-right"></i> Rendimentos
                            tributáveis
                        </h6>
                    </a>
                    <!-- Card Header - Dropdown -->
                    <div class="collapse" id="taxable_income">
                        <div class="card-body">
                            <form @submit="update('taxable_income', $event)">
                                <div class="row mt-2">
                                    <div class="col-md-12 col-xl-12 col-sm-12" v-for="item in taxable_income"
                                        :key="item.id">
                                        <div class="form-check">

                                            <input class="form-check-input" type="checkbox" :id="'check_' + item.id"
                                                :value="item.id" v-model="item.selected">
                                            <label class="form-check-label" :for="'check_' + item.id">
                                                {{ item.value }}
                                            </label>

                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                class="fa fa-save"></i> Atualizar</button>
                                        <router-link to="/category" class="btn btn-danger ml-3"><i
                                                class="fa fa-times"></i>
                                            Cancelar</router-link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Accordion -->
                    <a href="#no_taxable_income" class="d-block card-header py-3" data-toggle="collapse" role="button"
                        aria-expanded="true" aria-controls="no_taxable_income">
                        <h6 class="m-0 font-weight-bold text-primary"><i class="fa fa-caret-right"></i> Rendimentos não
                            tributáveis
                        </h6>
                    </a>
                    <!-- Card Header - Dropdown -->
                    <div class="collapse" id="no_taxable_income">
                        <div class="card-body">
                            <form @submit="update('no_taxable_income', $event)">
                                <div class="row mt-2">
                                    <div class="col-md-12 col-xl-12 col-sm-12" v-for="item in no_taxable_income"
                                        :key="item.id">
                                        <div class="form-check">

                                            <input class="form-check-input" type="checkbox" :id="'check_' + item.id"
                                                :value="item.id" v-model="item.selected">
                                            <label class="form-check-label" :for="'check_' + item.id">
                                                {{ item.value }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                class="fa fa-save"></i> Atualizar</button>
                                        <router-link to="/category" class="btn btn-danger ml-3"><i
                                                class="fa fa-times"></i>
                                            Cancelar</router-link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Accordion -->
                    <a href="#good_or_right" class="d-block card-header py-3" data-toggle="collapse" role="button"
                        aria-expanded="true" aria-controls="good_or_right">
                        <h6 class="m-0 font-weight-bold text-primary"><i class="fa fa-caret-right"></i> Bens ou Direitos
                        </h6>
                    </a>
                    <!-- Card Header - Dropdown -->
                    <div class="collapse" id="good_or_right">
                        <div class="card-body">
                            <form @submit="update('good_or_right', $event)">
                                <div class="row" v-for="item in good_or_right" :key="item.id">
                                    <div class="col-md-12 col-xl-12 col-sm-12">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" :id="'check_' + item.id"
                                                :value="item.id" v-model="item.selected">
                                            <label class="form-check-label" :for="'check_' + item.id">
                                                {{ item.value }}
                                            </label>
                                            <input v-if="item.selected && item.value != 'ND'" type="number" min="1"
                                                class="form-control form-control-sm" v-model.number="item.amount"
                                                placeholder="Quantidade">
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                class="fa fa-save"></i> Atualizar</button>
                                        <router-link to="/category" class="btn btn-danger ml-3"><i
                                                class="fa fa-times"></i>
                                            Cancelar</router-link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Accordion -->
                    <a href="#stock_or_investment" class="d-block card-header py-3" data-toggle="collapse" role="button"
                        aria-expanded="true" aria-controls="stock_or_investment">
                        <h6 class="m-0 font-weight-bold text-primary"><i class="fa fa-caret-right"></i> Ações e
                            Investimentos
                        </h6>
                    </a>
                    <!-- Card Header - Dropdown -->
                    <div class="collapse" id="stock_or_investment">
                        <div class="card-body">
                            <form @submit="update('stock_or_investment', $event)">
                                <div class="row mt-2">
                                    <div class="col-md-12 col-xl-12 col-sm-12" v-for="item in stock_or_investment"
                                        :key="item.id">
                                        <div class="form-check">

                                            <input class="form-check-input" type="checkbox" :id="'check_' + item.id"
                                                :value="item.id" v-model="item.selected">
                                            <label class="form-check-label" :for="'check_' + item.id">
                                                {{ item.value }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                class="fa fa-save"></i> Atualizar</button>
                                        <router-link to="/category" class="btn btn-danger ml-3"><i
                                                class="fa fa-times"></i>
                                            Cancelar</router-link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Accordion -->
                    <a href="#mei" class="d-block card-header py-3" data-toggle="collapse" role="button"
                        aria-expanded="true" aria-controls="mei">
                        <h6 class="m-0 font-weight-bold text-primary"><i class="fa fa-caret-right"></i> MEI
                        </h6>
                    </a>
                    <!-- Card Header - Dropdown -->
                    <div class="collapse" id="mei">
                        <div class="card-body">
                            <form @submit="update('mei', $event)">
                                <div class="row mt-2">
                                    <div class="col-md-12 col-xl-12 col-sm-12" v-for="item in mei" :key="item.id">
                                        <div class="form-check">

                                            <input class="form-check-input" type="checkbox" :id="'check_' + item.id"
                                                :value="item.id" v-model="item.selected">
                                            <label class="form-check-label" :for="'check_' + item.id">
                                                {{ item.value }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                class="fa fa-save"></i> Atualizar</button>
                                        <router-link to="/category" class="btn btn-danger ml-3"><i
                                                class="fa fa-times"></i>
                                            Cancelar</router-link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Accordion -->
                    <a href="#passwordGov" class="d-block card-header py-3" data-toggle="collapse" role="button"
                        aria-expanded="true" aria-controls="passwordGov">
                        <h6 class="m-0 font-weight-bold text-primary"><i class="fa fa-caret-right"></i> Acesso Gov
                        </h6>
                    </a>
                    <!-- Card Header - Dropdown -->
                    <div class="collapse" id="passwordGov">
                        <div class="card-body">
                            <form @submit="update('password_gov', $event)">
                                <div class="row mt-2">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <div class="alert alert-danger" v-if="ir.password_gov == ''">
                                            O(A) declarante optou por não enviar a senha GOV.
                                        </div>
                                    </div>

                                    <input type="text" v-model="ir.password_gov" placeholder="******"
                                        class="form-control">
                                </div>
                                <div class="row mt-3">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                class="fa fa-save"></i> Atualizar</button>
                                        <router-link to="/category" class="btn btn-danger ml-3"><i
                                                class="fa fa-times"></i>
                                            Cancelar</router-link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Accordion -->
                    <a href="#document" class="d-block card-header card-info py-3" data-toggle="collapse" role="button"
                        aria-expanded="true" aria-controls="document">
                        <h6 class="m-0 font-weight-bold text-primary"><i class="fa fa-caret-right"></i> Documentos
                        </h6>
                    </a>
                    <!-- Card Header - Dropdown -->
                    <div class="collapse" id="document">
                        <div class="card-body">
                            <form @submit="update('', $event)">
                                <div class="row">
                                    <div class="col-xl-4 col-md-4 col-sm-12" v-for="(itens, section) in ir.documents"
                                        :key="section">
                                        <div class="card">
                                            <div class="card-header bg-primary text-white">{{ section }}</div>
                                            <div class="card-body">
                                                <div class="table-responsive">
                                                    <table class="table" id="dataTable" width="100%" cellspacing="0">
                                                        <thead>
                                                            <tr>
                                                                <th>Nome</th>
                                                                <th>Tipo</th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="item in itens" :key="item.id">
                                                                <td>{{ item.description }} </td>
                                                                <td>{{ item.extension }}</td>
                                                                <td>
                                                                    <div class="dropdown">
                                                                        <button class="btn btn-primary dropdown-toggle"
                                                                            type="button" id="dropdownMenuButton"
                                                                            data-toggle="dropdown" aria-haspopup="true"
                                                                            aria-expanded="false">
                                                                            Ações
                                                                        </button>
                                                                        <div class="dropdown-menu animated--fade-in"
                                                                            aria-labelledby="dropdownMenuButton">
                                                                            <a class="dropdown-item" href="#"
                                                                                @click="openPdf(item.id)"
                                                                                v-if="item.extension == 'pdf'">Visualizar
                                                                                PDF</a>
                                                                            <a class="dropdown-item" href="#"
                                                                                @click="downloadFile(item.id, item.description)">Baixar
                                                                                aquivo</a>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="modalDisplayViewPdf" class="modal" :style="{ display: modalDisplayViewPdf }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" @click="closeModalViewPdf()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <h4 v-if="messageLoading != ''">{{ messageLoading }}</h4>
                        <PdfViewer :url="urlPdf" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="closeModalViewPdf()"><i
                                class="fa fa-times"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'


import PdfViewer from '@/components/PdfViewer.vue';

export default {
    directives: { mask, money: VMoney },
    components: {
        Loading, PdfViewer
    },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            taxable_income: [],
            no_taxable_income: [],
            good_or_right: [],
            stock_or_investment: [],
            mei: [],
            documents: [],
            ir: {
                id: '',
                document: '',
                name: '',
                email: '',
                phone: '',
                password_gov: '',
                amount_received: '',
                amount_pay: '',
                documents: [],
            },
            enable_error_list: false,
            errors: [],
            viewPdf: false,
            urlPdf: '',
            messageLoading: '',
            modalDisplayViewPdf: 'none',
             money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
        }
    },

    computed: {
        isDisabled: function () {
            return this.ir.document != '' && this.ir.name != '' && this.ir.email != '' && this.ir.phone != '';
        }
    },
    mounted() {
        this.isLoading = false;
        const id = this.$route.params.id;
        this.ir.id = id;
        this.getIr();
    },
    methods: {
        onCancel() { },
        formatReal(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },
        checkAnuallTaxableIncone() {
            let taxable_income = JSON.parse(this.ir.taxable_income);
            taxable_income.forEach(item => {
                this.taxable_income.push({
                    id: item.id, value: item.value, selected: item.selected
                })
            });
        },
        checkAnuallNoTaxableIncone() {
            let no_taxable_income = JSON.parse(this.ir.no_taxable_income);
            no_taxable_income.forEach(item => {
                this.no_taxable_income.push({
                    id: item.id, value: item.value, selected: item.selected
                })
            });
        },
        checkGoodOrRight() {
            let good_or_right = JSON.parse(this.ir.good_or_right);
            good_or_right.forEach(item => {
                this.good_or_right.push({
                    id: item.id, value: item.value, selected: item.selected, amount: item.amount
                })
            });
        },
        checkStockOrInvestment() {
            let stock_or_investment = JSON.parse(this.ir.stock_or_investment);
            stock_or_investment.forEach(item => {
                this.stock_or_investment.push({
                    id: item.id, value: item.value, selected: item.selected
                })
            });
        },
        checkMei() {
            let mei = JSON.parse(this.ir.mei);
            mei.forEach(item => {
                this.mei.push({
                    id: item.id, value: item.value, selected: item.selected
                })
            });
        },

        getIr() {
            api.get('/ir/' + this.ir.id)
                .then((response) => {
                    this.isLoading = false;
                    this.ir = response.data.ir;
                    this.ir.amount_received = this.formatReal(this.ir.amount_received.trim());
                    this.ir.amount_pay = this.formatReal(this.ir.amount_pay.trim());
                    this.checkAnuallTaxableIncone();
                    this.checkAnuallNoTaxableIncone();
                    this.checkGoodOrRight();
                    this.checkStockOrInvestment();
                    this.checkMei();
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

        update(type, event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            this.ir.taxable_income = this.taxable_income;
            this.ir.no_taxable_income = this.no_taxable_income;
            this.ir.good_or_right = this.good_or_right;
            this.ir.stock_or_investment = this.stock_or_investment;
            this.ir.mei = this.mei;
            api.put('/ir/' + this.ir.id, { 'data': this.ir, 'type': type })
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Declaração atualizada com sucesso!",
                        type: 'success'
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })
        },

        async downloadFile(file_id, description) {
            this.isLoading = true;
            api.get('/ir/' + file_id + '/downloadFile', { responseType: 'blob' })
                .then((response) => {
                    const contentType = response.headers.get('Content-Type');
                    this.isLoading = false;
                    const blob = new Blob([response.data], { type: contentType })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob);
                    const name_file = description ? description : this.client.name + '_' + this.generateRandom();
                    link.download = name_file;
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalNewFile();
                    handleRequestErrors(error.status, error);
                })
        },

        openPdf(file_id) {
            this.messageLoading = 'Carregando...';
            this.isLoading = true;
            this.downloadPdfToView(file_id);
        },

        async downloadPdfToView(file_id) {
            this.urlPdf = '';
            const response = await api.get('/ir/' + file_id + '/downloadFile', { responseType: 'blob' })
            const url = window.URL.createObjectURL(new Blob([response.data]));
            this.urlPdf = url;
            this.viewPdf = true;
            this.messageLoading = '';
            this.showModalViewPdf();
            this.isLoading = false;
        },
        showModalViewPdf() {
            this.modalDisplayViewPdf = 'block';
        },

        closeModalViewPdf() {
            this.modalDisplayViewPdf = 'none';
            this.urlPdf = '';
        },
    }
}
</script>

<style lang="scss" scoped></style>